export default __webpack_public_path__ + "static/media/swap.fc336027.svg";